import { useQuery } from "@tanstack/react-query";
import httpClient from "../httpClient";
import { isHttpError } from "../httpError";
import { ErrorResponse } from "../../models/apiResponse";
import { Customer } from "../../models/Service";

const TRANSIENT_CLIENT_STATUSES = [408, 429];

const useQueryCustomer = ({
  customerCode,
  corporateId,
  enabled = false,
  authorisation = "",
}: {
  customerCode: string;
  corporateId: string;
  enabled?: boolean;
  authorisation?: string;
}) => {
  return useQuery(
    [`/corporate-subsidiary/${corporateId}/customer/${customerCode}`],
    () =>
      httpClient(
        `corporate-subsidiary/${corporateId}/customer/${customerCode}`,
        { authorisation }
      ).get<Customer | ErrorResponse>(),
    {
      staleTime: 1000 * 60 * 1,
      refetchOnWindowFocus: false,
      // A 4xx (e.g. 404 unknown code) is the server's answer, not a fault;
      // retrying only delays the not-found message by several seconds. A
      // timeout (408) or a rate limit (429) is transient, so it is retried.
      retry: (failureCount, error) =>
        !(
          isHttpError(error) &&
          error.status >= 400 &&
          error.status < 500 &&
          !TRANSIENT_CLIENT_STATUSES.includes(error.status)
        ) && failureCount < 3,
      enabled,
    }
  );
};

export default useQueryCustomer;
